import axiosInstance from "../../axios";
import urls from "../../Utils/urls";

// Derived from an existing /api/v1 constant so this file needs no edit to urls.js
// (that file carries a local, never-committed UAT edit in this repo — see CLAUDE.md).
const API_V1 = urls.admin.getAuthToken.replace(/\/auth\/get_auth_token$/, "");

// These are pre-session calls: the response body is returned as-is and errors propagate,
// so callers map them with describeMfaError. Never log a request or response here.
export const startLogin = async ({ username, password, fingerprint }) =>
  (await axiosInstance.post(`${API_V1}/auth/login/start`, { username, password, fingerprint })).data;

export const requestChallenge = async ({ mfaTx, method }) => {
  await axiosInstance.post(`${API_V1}/auth/mfa/challenge`, { mfa_tx: mfaTx, method });
};

export const verifyCode = async ({ mfaTx, method, code }) =>
  (await axiosInstance.post(`${API_V1}/auth/mfa/verify`, { mfa_tx: mfaTx, method, code })).data;

// SSN/TIN fallback: the first code from the new authenticator activates it and returns the session.
export const confirmLoginEnrollment = async ({ mfaTx, enrollmentId, code }) =>
  (await axiosInstance.post(`${API_V1}/auth/mfa/enroll-confirm`, { mfa_tx: mfaTx, enrollment_id: enrollmentId, code })).data;

// Login setup (docs/specs/login-setup.md §2): no session until the phone and authenticator steps are done.
// `phone` null = the number on file, so the key is left out.
export const startPhone = async ({ mfaTx, phone }) =>
  (await axiosInstance.post(`${API_V1}/auth/mfa/phone-start`, { mfa_tx: mfaTx, ...(phone ? { phone } : {}) })).data;

export const confirmPhone = async ({ mfaTx, code }) =>
  (await axiosInstance.post(`${API_V1}/auth/mfa/phone-confirm`, { mfa_tx: mfaTx, code })).data;

// A fresh QR when the first expired.
export const restartLoginEnrollment = async ({ mfaTx }) =>
  (await axiosInstance.post(`${API_V1}/auth/mfa/enroll-start`, { mfa_tx: mfaTx })).data;
